import React from 'react';
import { FileText } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6 py-24">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-center mb-12">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center">
              <FileText className="h-8 w-8 text-blue-600" />
            </div>
          </div>
          
          <h1 className="text-5xl font-bold text-center text-slate-900 mb-6">Terms & Conditions</h1>
          <p className="text-center text-gray-600 mb-16">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="bg-white rounded-2xl shadow-lg p-12 space-y-8">
            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using Recit's services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">2. Use License</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Permission is granted to temporarily download one copy of the materials (information or software) on Recit's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial)</li>
                <li>Attempt to decompile or reverse engineer any software contained on Recit's website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">3. Creator Accounts</h2>
              <p className="text-gray-700 leading-relaxed">
                Creators who upload content to Recit retain full ownership of their intellectual property. By uploading content, creators grant Recit a non-exclusive license to display, distribute, and market the content on the platform. Creators are responsible for ensuring they have the right to upload and sell any content shared on the platform.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">4. User Conduct</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Users agree to use Recit in a manner consistent with applicable laws and regulations. Prohibited activities include:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Uploading content that infringes on intellectual property rights</li>
                <li>Engaging in fraudulent transactions</li>
                <li>Harassing or threatening other users</li>
                <li>Attempting to gain unauthorized access to the platform</li>
                <li>Distributing malware or other harmful software</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">5. Payment Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                All transactions on Recit are processed through Recit Credits. Creators receive payment for their digital assets according to the pricing they set. Recit charges a service fee on each transaction, which will be clearly displayed before purchase. Refund policies vary by creator and will be specified on individual product listings.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">6. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All content uploaded to Recit remains the property of the original creator. Users who purchase digital assets receive a license to use the content as specified in the product listing. This license does not transfer ownership or allow for redistribution unless explicitly stated.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">7. Disclaimer</h2>
              <p className="text-gray-700 leading-relaxed">
                The materials on Recit's website are provided on an 'as is' basis. Recit makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">8. Limitations</h2>
              <p className="text-gray-700 leading-relaxed">
                In no event shall Recit or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Recit's website, even if Recit or a Recit authorized representative has been notified orally or in writing of the possibility of such damage.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">9. Modifications</h2>
              <p className="text-gray-700 leading-relaxed">
                Recit may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">10. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These terms and conditions are governed by and construed in accordance with the laws of Singapore and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-slate-900 mb-4">11. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about these Terms & Conditions, please contact us through our website at{' '}
                <a href="https://go.recit.sg" className="text-blue-600 hover:text-cyan-600 font-medium">go.recit.sg</a>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;